"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var React = require('react');
var board_1 = require('../components/board');
var patterns_1 = require('./patterns');
var controls_1 = require('../components/controls');
var utils_1 = require('../utils');
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        _super.call(this);
        var activePatterns = utils_1.generateRandomActivePatterns();
        var numOfRows = 50;
        var numOfCellsInRow = 50;
        var initialRow = utils_1.createRandomRow(numOfCellsInRow);
        this.state = {
            activePatterns: activePatterns,
            boardState: utils_1.createBoard(numOfRows, initialRow, activePatterns),
            initialRow: initialRow,
            isPlaying: false,
            numOfCellsInRow: numOfCellsInRow,
            numOfRows: numOfRows,
            rowKeyOffset: 0
        };
        this.changePattern = this.changePattern.bind(this);
        this.alterBoard = this.alterBoard.bind(this);
        this.generateRandomBoard = this.generateRandomBoard.bind(this);
        this.togglePlay = this.togglePlay.bind(this);
        this.play = this.play.bind(this);
    }
    default_1.prototype.changePattern = function (signature, newState) {
        var _a = this.state, activePatterns = _a.activePatterns, boardState = _a.boardState, initialRow = _a.initialRow, isPlaying = _a.isPlaying, numOfCellsInRow = _a.numOfCellsInRow, numOfRows = _a.numOfRows, rowKeyOffset = _a.rowKeyOffset;
        var newActivePatterns = activePatterns.indexOf(signature) >= 0
            ? activePatterns.filter(function (p) { return p !== signature; })
            : activePatterns.concat([signature]);
        this.setState({
            activePatterns: newActivePatterns,
            boardState: utils_1.createBoard(numOfRows, initialRow, newActivePatterns),
            initialRow: initialRow,
            numOfRows: numOfRows,
            numOfCellsInRow: numOfCellsInRow,
            isPlaying: isPlaying,
            rowKeyOffset: rowKeyOffset
        });
    };
    default_1.prototype.alterBoard = function (rowIndex, cellIndex) {
        var _a = this.state, activePatterns = _a.activePatterns, boardState = _a.boardState, initialRow = _a.initialRow, isPlaying = _a.isPlaying, numOfCellsInRow = _a.numOfCellsInRow, numOfRows = _a.numOfRows, rowKeyOffset = _a.rowKeyOffset;
        var row = boardState[rowIndex];
        var newState = row[cellIndex] === '0' ? '1' : '0';
        var alteredRow = row
            .slice(0, cellIndex)
            .concat(newState)
            .concat(row.slice(cellIndex + 1));
        var newBoard = boardState
            .slice(0, rowIndex)
            .concat(utils_1.createBoard(numOfRows - rowIndex, alteredRow, activePatterns));
        this.setState({
            activePatterns: activePatterns,
            boardState: newBoard,
            initialRow: rowIndex === 0 ? alteredRow : initialRow,
            isPlaying: isPlaying,
            numOfRows: numOfRows,
            numOfCellsInRow: numOfCellsInRow,
            rowKeyOffset: rowKeyOffset
        });
    };
    default_1.prototype.generateRandomBoard = function () {
        var _a = this.state, activePatterns = _a.activePatterns, boardState = _a.boardState, initialRow = _a.initialRow, isPlaying = _a.isPlaying, numOfCellsInRow = _a.numOfCellsInRow, numOfRows = _a.numOfRows, rowKeyOffset = _a.rowKeyOffset;
        var newActivePatterns = utils_1.generateRandomActivePatterns();
        var newBoard = utils_1.createBoard(numOfRows, utils_1.createRandomRow(numOfCellsInRow), newActivePatterns);
        this.setState({
            activePatterns: newActivePatterns,
            boardState: newBoard,
            initialRow: newBoard[0],
            isPlaying: isPlaying,
            numOfCellsInRow: numOfCellsInRow,
            numOfRows: numOfRows,
            rowKeyOffset: rowKeyOffset
        });
    };
    default_1.prototype.togglePlay = function () {
        var _a = this.state, activePatterns = _a.activePatterns, boardState = _a.boardState, initialRow = _a.initialRow, isPlaying = _a.isPlaying, numOfCellsInRow = _a.numOfCellsInRow, numOfRows = _a.numOfRows, rowKeyOffset = _a.rowKeyOffset;
        if (isPlaying) {
            this.setState({
                activePatterns: activePatterns,
                boardState: boardState,
                initialRow: initialRow,
                isPlaying: false,
                numOfCellsInRow: numOfCellsInRow,
                numOfRows: numOfRows,
                rowKeyOffset: rowKeyOffset
            });
        }
        else {
            this.play(true);
        }
    };
    default_1.prototype.play = function (isInitial) {
        var _this = this;
        var _a = this.state, activePatterns = _a.activePatterns, boardState = _a.boardState, initialRow = _a.initialRow, isPlaying = _a.isPlaying, numOfCellsInRow = _a.numOfCellsInRow, numOfRows = _a.numOfRows, rowKeyOffset = _a.rowKeyOffset;
        if (!isInitial && !isPlaying) {
            return;
        }
        var lastRow = utils_1.getLastItem(boardState);
        var newRow = utils_1.createNextRow(lastRow, activePatterns);
        var newBoard = boardState
            .slice(1)
            .concat([newRow]);
        var newInitialRow = newBoard[0];
        this.setState({
            activePatterns: activePatterns,
            boardState: newBoard,
            initialRow: newInitialRow,
            isPlaying: true,
            numOfCellsInRow: numOfCellsInRow,
            numOfRows: numOfRows,
            rowKeyOffset: (rowKeyOffset + 1) % (numOfRows + 1)
        }, function () {
            setTimeout(_this.play, 50);
        });
    };
    default_1.prototype.render = function () {
        var _a = this.state, activePatterns = _a.activePatterns, boardState = _a.boardState, isPlaying = _a.isPlaying, rowKeyOffset = _a.rowKeyOffset;
        return (React.createElement("div", null, 
            React.createElement(controls_1.default, {generateRandomBoard: this.generateRandomBoard, togglePlay: this.togglePlay, isPlaying: isPlaying}), 
            React.createElement(patterns_1.default, {activePatterns: activePatterns, changePattern: this.changePattern}), 
            React.createElement(board_1.default, {alterBoard: this.alterBoard, isPlaying: isPlaying, rows: boardState, rowKeyOffset: rowKeyOffset})));
    };
    return default_1;
}(React.PureComponent));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;



/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/store.tsx
 ** module id = 3
 ** module chunks = 0
 **/